<template></template>
<script>
  export default {
    data() {
      return {
        player: _.tap(new Audio(), audio => {
          audio.addEventListener('ended', this.onEnded.bind(this));
        }),
      }
    },

    methods: {
      /**
       * @param {string} url
       * @return {Promise<void>}
       */
      play(url) {
        this.stop();
        this.player.src = url;

        return this.player.play();
      },

      /**
       * @emits {stop}
       */
      stop() {
        this.player.pause();
        this.$emit('stop');
      },

      /**
       * @emits {stop}
       */
      onEnded() {
        this.$emit('stop');
      },
    },

    beforeDestroy() {
      this.player.removeEventListener('ended', this.onEnded);
    }
  }
</script>
